import React, { Component } from 'react';
import Image from 'react-image-file';

import './ReviewInformationStep.css';

class ReviewInformationStep extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false
        };

        this.completeOnboarding = this.completeOnboarding.bind(this);
        this.renderSubmitButton = this.renderSubmitButton.bind(this);
    }

    renderImages() {
        if (this.props.collectedData.uploadStep.length === 0) {
            return <p> No images submitted.</p>
        }

        return this.props.collectedData.uploadStep.map((imgSrc, idx) => (
            <Image
                className="review-asset-image"
                file={imgSrc}
                key={idx}
                type={'img'}
                height={50}
            />
        ));
    }

    renderCategories() {
        return this.props.collectedData.selectCategoriesStep.map((category, idx) => (
            <kbd className="info-field-kbd" key={idx}>
                {category.label}
            </kbd>
        ));
    }

    renderSizes() {
        let elements = [];
        // eslint-disable-next-line
        this.props.collectedData.selectCategoriesStep.map((category, idx) => {
            elements.push(<h5 className="size-header" key={idx}>{category.label}</h5>);
            // Get the sizes
            let sizeArr = this.props.collectedData.selectSizesStep[category.internalName];
            for (let i=0; i < sizeArr.length; i++) {
                elements.push(
                    <kbd className="info-field-kbd" key={`${i}-${category.internalName}`}>{sizeArr[i]}</kbd>
                );
            }
        });

        return elements;
    }

    renderPrices() {
        let pricesData = this.props.collectedData.selectPricesStep;
        let keys = Object.keys(pricesData);

        return keys.map((key, idx) => (
           <div key={`price-header-${idx}`}>
               <h5 className="price-header">{pricesData[key].label}</h5>
               <kbd className="info-field-kbd price-kbd">$ {pricesData[key].price}</kbd>
               <br />
           </div>
        ));
    }

    renderSubmitButton() {
        if (!this.state.loading) {
            return (
                <button onClick={this.completeOnboarding} className="complete-onboarding-button">
                    <i className="ion ion-checkmark" />
                </button>
            );
        }

        return (
            <button style={{pointerEvents: 'none'}} className="complete-onboarding-button">
                <div className="lds-css ng-scope">
                    <div className="lds-rolling">
                        <div>
                        </div>
                    </div>
                </div>
            </button>
        );
    }

    completeOnboarding() {
        // Hide the button
        this.setState({
            loading: true
        })

        // Step auto increments in parent
        this.props.completeOnboarding(this.props.collectedData);
    }

    render() {
        return (
          <div className="review-information-step">
              <div className="component-content container">
                  <h2 className="review-header">Review account information:</h2>
                  <p className="review-subheader">Editing info currently returning to the step and changing the information.</p>
                  <hr className="review-horizontal-row" />

                  <div className="review-information-container">
                      <div className="row ">
                        <div className="col-md-6">
                            <div className="info-div">
                                <h3>Selected prices:</h3>
                                <div className="review-categories-sizes-container">
                                    {this.renderPrices()}
                                </div>
                            </div>
                            <hr/>
                        </div>

                        <div className="col-md-6">
                            <div className="info-div">
                                <h3>Submitted assets:</h3>
                                <div className="review-assets-container">
                                    {this.renderImages()}
                                </div>
                            </div>
                            <hr/>
                        </div>

                        <div className="col-md-6">
                            <div className="info-div">
                                <h3 className="info-div-header">Product categories:</h3>
                                <div className="review-categories-sizes-container">
                                    {this.renderCategories()}
                                </div>
                                <hr/>

                                <h3 style={{marginTop: 30}} className="info-div-header">Product sizes:</h3>
                                <div className="review-categories-sizes-container">
                                    {this.renderSizes()}
                                </div>
                            </div>
                            <hr/>
                        </div>

                      </div>
                  </div>

                  <button id="prevStepButton" onClick={this.props.previousStep} className="circle-step-button">
                      <i className="ion ion-android-arrow-back" />
                  </button>

                  {this.renderSubmitButton()}
              </div>
          </div>
        );
    }


}

export default ReviewInformationStep;


// WEBPACK FOOTER //
// ./src/components/App/components/Main/components/Onboard/StepComponents/ReviewInformationStep/ReviewInformationStep.js